module.exports = __webpack_public_path__ + "static/media/StockTruck5.b41a8f6d.jpg";